import React, { FC, useEffect, useMemo, useState } from 'react';
import { Navigate, Outlet } from 'react-router';

import { isAddressEqual } from 'viem';

import { useAuth } from '@contexts/common/AuthorizationContext';

import Loader from '@components/common/Loader';

import { ADMINS_LIST_ADDRESS } from '@constants/common/common.constants';
import { PATH_ADMIN } from '@constants/common/routes.constants';

interface Props {
  path: string;
  redirectPath: string;
}

export const PrivateRoute: FC<Props> = ({ path, redirectPath }) => {
  const { account, isConnected, isAuthReady } = useAuth();

  const isAllowed = useMemo(() => {
    if (!account || !isConnected) return false;

    if (path === PATH_ADMIN) {
      return ADMINS_LIST_ADDRESS.some((admin) =>
        isAddressEqual(admin, account),
      );
    }

    return true;
  }, [path, account, isConnected]);

  if (!isAuthReady) {
    return (
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Loader size={36} />
      </div>
    );
  }

  return isAllowed ? <Outlet /> : <Navigate to={redirectPath} replace />;
};
